export const CONFIRMED_GET_SETTINGS = "CONFIRMED_GET_SETTINGS";
export const CONFIRMED_UPDATE_SETTING = "CONFIRMED_UPDATE_SETTING";
